import React from 'react';
import { FileInput, FileItem } from '../File';
import { CancelButton, NextButton } from '../Button';

interface ImportFilePaneProps {
  file: File | null;
  setFile: (file: File | null) => void;

  handleClose: () => void;
  handleNext: () => void;

  acceptedTypes?: string;
}

export default function ImportFilePane({
  file,
  setFile,
  handleClose,
  handleNext,
  acceptedTypes = 'txt',
}: ImportFilePaneProps) {
  const handleUpload = async () => {
    if (!file) return;
    handleNext();
  };

  const handleFiles = (files: FileList | null) => {
    if (!files) return;
    if (!files.length) return;

    setFile(files[0]);
  };

  const handleRemove = () => {
    setFile(null);
  };

  return (
    <div className='flex h-full flex-col justify-between gap-2'>
      <div>
        {!file ? (
          <FileInput onFiles={handleFiles} acceptedTypes={acceptedTypes} />
        ) : (
          <FileItem file={file} onRemove={handleRemove} />
        )}
      </div>
      <div>
        <div className='flex justify-end'>
          <div>
            <CancelButton onClick={handleClose} />
            <NextButton disabled={!file} onClick={handleUpload} />
          </div>
        </div>
      </div>
    </div>
  );
}
